import "bootstrap/js/dist/util";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
// import 'bootstrap/js/dist/carousel';
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
// import 'bootstrap/js/dist/popover';
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
// import 'bootstrap/js/dist/toast';
// import 'bootstrap/js/dist/tooltip';

// import loadDrift from './modules/drift';

// Hamburger
$(".hamburger").click(function() {
	$(this).toggleClass("is-active");
});

// Before and after images
function initComparisons() {
	var imgComps, i;

	/* Find all elements with an "overlay" class: */
	imgComps = document.getElementsByClassName("img-comp-overlay");

	for (i = 0; i < imgComps.length; i++) {
		/* Once for each "overlay" element:
		pass the "overlay" element as a parameter when executing the compareImages function: */
		compareImages(imgComps[i]);
	}

	function compareImages(img) {
		var slider,
			clicked = 0,
			w,
			h;

		/* Get the width and height of the img element */
		w = img.offsetWidth;
		h = img.offsetHeight;

		/* Set the width of the img element to 50%: */
		img.style.width = w / 2 + "px";

		/* Create slider: */
		slider = document.createElement("DIV");
		slider.setAttribute("class", "img-comp-slider");

		/* Insert slider */
		img.parentElement.insertBefore(slider, img);

		/* Position the slider in the middle: */
		slider.style.top = h / 2 - slider.offsetHeight / 2 + "px";
		slider.style.left = w / 2 - slider.offsetWidth / 2 + "px";

		/* Execute a function when the mouse button is pressed: */
		slider.addEventListener("mousedown", slideReady);

		/* And another function when the mouse button is released: */
		window.addEventListener("mouseup", slideFinish);

		/* Or touched (for touch screens: */
		slider.addEventListener("touchstart", slideReady);

		/* And released (for touch screens: */
		window.addEventListener("touchend", slideFinish);

		function slideReady(e) {
			/* Prevent any other actions that may occur when moving over the image: */
			e.preventDefault();

			/* The slider is now clicked and ready to move: */
			clicked = 1;

			/* Execute a function when the slider is moved: */
			window.addEventListener("mousemove", slideMove);
			window.addEventListener("touchmove", slideMove);
		}

		function slideFinish() {
			/* The slider is no longer clicked: */
			clicked = 0;
		}

		function slideMove(e) {
			var pos;

			/* If the slider is no longer clicked, exit this function: */
			if (clicked === 0) {
				return false;
			}

			/* Get the cursor's x position: */
			pos = getCursorPos(e);

			/* Prevent the slider from being positioned outside the image: */
			if (pos < 0) {
				pos = 0;
			}
			if (pos > w) {
				pos = w;
			}

			/* Execute a function that will resize the overlay image according to the cursor: */
			slide(pos);
		}

		function getCursorPos(e) {
			var a,
				x = 0;
			e = e || window.event;

			/* Get the x positions of the image: */
			a = img.getBoundingClientRect();

			/* Calculate the cursor's x coordinate, relative to the image: */
			x = e.pageX - a.left;

			/* Consider any page scrolling: */
			x = x - window.pageXOffset;
			return x;
		}

		function slide(x) {
			/* Resize the image: */
			img.style.width = x + "px";

			/* Position the slider: */
			slider.style.left = img.offsetWidth - slider.offsetWidth / 2 + "px";
		}
	}
}

initComparisons();

jQuery(document).ready(function($) {
	$(".current-menu-item")
		.parent()
		.addClass("active-submenu shown");

	$(".menu .dropdown > a").click(function(e) {
		e.preventDefault();
		if (
			$(this)
				.parent()
				.children(".sub-menu:first")
				.is(":visible")
		) {
			$(this)
				.parent()
				.children(".sub-menu:first")
				.hide();
		} else {
			$(this)
				.parent()
				.children(".sub-menu:first")
				.show()
				.addClass("shown");
		}
	});
});

// Drawer
$(".drawer-trigger").click(function(e) {
	e.preventDefault();

	$(".drawer-section").toggleClass("drawer-section-open");
	$("body").toggleClass("drawer-open");
});

$(".drawer-overlay").click(function(e) {
	e.preventDefault();

	$(".drawer-section").toggleClass("drawer-section-open");
	$("body").toggleClass("drawer-open");
});

$(".close-drawer").click(function(e) {
	e.preventDefault();

	$(".drawer-section").toggleClass("drawer-section-open");
	$("body").toggleClass("drawer-open");
});

// Back to top button
(function($) {
	let button = $("#buttonBackToTop");

	button.click(function() {
		$("html, body").animate({ scrollTop: 0 }, "slow");
		return false;
	});

	$(window).on("scroll", function() {
		if ($(window).scrollTop() > 1250) {
			button.fadeIn();
		} else {
			button.fadeOut();
		}
	});
})(jQuery);

// Mobile menu search modal
$(".mobile-search-link .nav-link").on("click", function() {
	$("#searchModal").modal("toggle");
});

// Drift
// setTimeout(function () {
// 	loadDrift('hufw2w578byc');
// }, 10000);

// Smooth Scroll
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener("click", function(e) {
		e.preventDefault();

		document.querySelector(this.getAttribute("href")).scrollIntoView({
			behavior: "smooth"
		});
	});
});

// Green Sock
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

if (document.querySelector(".counts")) {
	const items = document.querySelectorAll(".counts");

	// Custom formatter function to add commas
	function formatNumber(value) {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}

	gsap.from(items, {
		textContent: 0,
		duration: 2,
		snap: { textContent: 1 },
		scrollTrigger: {
			trigger: '.counts',
			start: 'top 80%', // Adjust this to control when the animation starts
			once: false // Animation should only happen once
		},
		onUpdate: function() {
			items.forEach(item => {
				item.textContent = formatNumber(Math.floor(item.textContent));
			});
		}
	});
}
